var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_logged_in && !_vm.loading)?_c('div',{staticClass:"favourite-component"},[_c('span',{staticClass:"favourite-component--toggle",on:{"click":function($event){return _vm.toggleFavourite()}}},[(!_vm.is_favourited)?_c('icon-heart-outline'):_vm._e(),_vm._v(" "),(_vm.is_favourited)?_c('icon-heart-filled'):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }